import React, { useState } from 'react'
import Header from '../components/Header'
import SideBar from '../components/SideBar'
import InputFile from '../components/InputFile'
import Loader from '../components/Loader'
import { uploadResume } from '../api'

function AiScreen() {

  const [appState,setAppState]=useState("");
  const [isUploading,setIsUploading] = useState(false);
  const [response,setResponse] = useState({
    answer:""
   })
   const [isLoading,setIsLoading] = useState(false)
   const [uploadProgress, setUploadProgress] = useState(0);

const [requirement, setRequirement] = useState("");
const [file, setFile]=useState('')
   const [windowState,setWindowState]=useState("init")
const [aiResponse,setAiResponse]=useState()
   const handleFileInputChange =async (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      // Handle the file upload here, e.g., display the file name
      console.log('Selected file:', selectedFile.name);
      setIsLoading(true)
      setFile(selectedFile)
  // let response =   await uploadResume(selectedFile)

  setTimeout(()=>{

    setIsLoading(false);
    setWindowState("ready")
  },1000)

    }
  };

  const uploadFileAndGenerateResponse = async ()=>{

if(requirement&&file){

setIsLoading(true)

try{
  let serverResp = await uploadResume(file,requirement)
//   let serverResp= {
//     data:{
//       // text:`Based on the provided resume, the candidate does not meet the requirements for the Node.js developer position with 8 years+ of experience and a post-graduation in IT. The candidate's experience is in web development as a Python developer, and they have 4+ years of experience. Additionally, there is no mention of Node.js experience or a post-graduation in IT. Therefore, it would not be appropriate to suggest technical questions for a Node.js developer position to this candidate.`,
// text:`Based on the information provided in the resume, the candidate has 4+ years of experience in web development as a Python developer. They have experience with various technologies including Python, Django, and MySQL. However, there is no mention of experience with Node.js, Express.js, React.js, or TypeScript. \n\nBased on the requirements of the job, which include 2 years of experience and strong CS background, it seems that the candidate does not meet the requirements. \n\nEvaluation: Not Apt for the requirement based on the resume.\n\nTechnical Questions:\n\n1. Can you explain the concept of object-oriented programming and how it is used in Python?\n2. How would you handle runtime errors in Python? Can you provide an example?\n3. Have you worked with Django REST Framework? Can you explain the purpose and benefits of using it?\n4. How would you handle authentication and authorization in a Django web application?\n5. Can you explain the process of unit testing in Python? What tools or libraries have you used for unit testing?\n6. Have you worked with Git/GitHub for version control? Can you explain how you would handle code collaboration and version management?\n7. Can you explain the concept of Pickling and Unpickling in Python and how it is used for handling JSON data?\n8. Have you used any cloud services like AWS for deploying web applications? Can you explain the process?\n9. Have you worked with Python Pandas? Can you provide an example of how you have used it in your previous projects?\n10. Can you explain the process of creating and using APIs in Python, specifically with Django and REST Framework?`,
//       message:'done',
//       status:true
//     }
//   }
  const lines = serverResp?.data?.split('\n');
  setAiResponse(lines)
  console.log("serverResponse",serverResp)
  setIsLoading(false)
}

catch(error){
console.log("error",error)
setIsLoading(false)

}
}

  }

  return (
    <>
    <Header/>
    <SideBar aiResponse={aiResponse} uploadFileAndGenerateResponse={uploadFileAndGenerateResponse} setRequirement={setRequirement} windowState={windowState} appState={appState} setAppState={setAppState} response={response} setResponse={setResponse} handleFileInputChange={handleFileInputChange} isLoading={isLoading} setIsLoading={setIsLoading}/>

    </>
  )
}

export default AiScreen